import { $t } from "@/i18n";

export const EMAIL_INTEGRATION_VISIBILITY = {
    PUBLIC: 'public',
    CLIENT: 'client',
    PRIVATE: 'private'
}

export const getEmailIntegrationTableHeaders = () => {
    return [
        {
            text: $t("Email"),
            value: "email",
        },
        {
            text: $t("Sender name"),
            value: "sender_name",
        },
        {
            text: $t("Who can use?"),
            value: "visibility"
        },
        {
            value: "edit"
        }
    ]
}

export const getEmailIntegrationVisibilities = (members, ownerId) => {
    let ret = [
        {
            name: $t('All'),
            value: EMAIL_INTEGRATION_VISIBILITY.PUBLIC
        },
        {
            name: $t('Client members'),
            value: EMAIL_INTEGRATION_VISIBILITY.CLIENT
        },
    ]

    const member = members.find(x => x.id === ownerId)
    ret.push({
        name: member ? member.name : $t('Only me'),
        value: EMAIL_INTEGRATION_VISIBILITY.PRIVATE
    })

    return ret
}

export const getTableEmailIntegrationVisibilityName = (members, emailVisibility, ownerId) => {
    if (emailVisibility === EMAIL_INTEGRATION_VISIBILITY.PRIVATE) {
        const member = members.find(x => x.id === ownerId)

        return member ? member.name : $t('Private')
    }

    return getEmailIntegrationVisibilities(members, ownerId).find(x => x.value === emailVisibility).name
}

export const getIntegrations = (companyId) => {
    return [
        {
            link: `/api/email_automation/gmail/get_token/${companyId}`,
            name: 'Gmail',
            img: require('@/assets/gmail-logo.svg')
        },
        {
            link: `/api/email_automation/outlook/get_token/${companyId}`,
            name: 'Microsoft 365',
            img: require('@/assets/outlook-logo.svg')
        }
    ]
}


export default {
    getEmailIntegrationTableHeaders,
    getIntegrations,
    getEmailIntegrationVisibilities,
    getTableEmailIntegrationVisibilityName
}